export class ConfigPaq {
    cat: string = '';
    config: Array<Config> = [];
  }
  
  export class Config {
    nombre: string = '';
    paquetes: Array<Paquetes> = [];
  }
  export class Paquetes {
    basic: boolean = false;
    duenio: number = 0;
    cve: string = '';
    paq: number = 0;
    ignoreBasic?: boolean = false;
    ignoreDuenio?: boolean = false;
  }
  
  export class GenericOptions {
    key?: string | number;
    name?: string;
    configPaq?: ConfigPaq;
  }
  
  export class BasicDataCp {
    estado: string = '';
    estadoID: number = 0;
    municipio: string = '';
    municipioID: number = 0;
  }
  
  export class ZurichColonias {
    ciudad: string = "";
    consecutivo: number = 0;
    cp: string = '';
    descripcion: string = '';
    estado: string = '';
    fhm: string = '';
    tev: string = '';
    tipo: string = '';
    zona: string = '';
    zurichColoniaID: number = 0;
  }

export class ChubbColonias {
  PaisID: number = 0;
  PaisNombre: string = "";
  EstadoID: number = 0;
  EstadoNombre: string = "";
  MunicipioId: number = 0;
  MunicipioNombre: string = "";
  PoblacionId: number = 0;
  PoblacionNom: string = "";
  ColoniaId: number = 0;
  ColoniaDsc: string = "";
  Lat: number = 0;
  Lng: number = 0;
}